import Breadcrumb from '@components/Breadcrumb';
import { ROUTE_MARKET_HOME, ROUTE_MARKET_HUB } from '@/constants/routes';
import { BreadcrumbWrapper } from './styled';

type Props = {
  articleTitle: string;
  canonicalUrl: string;
};
export const ArticleBreadcrumb = ({ articleTitle, canonicalUrl }: Props) => (
  <BreadcrumbWrapper>
    <Breadcrumb
      list={[
        {
          name: 'Markets',
          dispatch: {
            type: ROUTE_MARKET_HOME,
          },
        },
        {
          name: 'Insights',
          dispatch: {
            type: ROUTE_MARKET_HUB,
          },
        },
        {
          name: articleTitle,
          canonicalUrl: canonicalUrl,
          documentSchemaOnly: true,
        },
      ]}
    />
  </BreadcrumbWrapper>
);
